import {
  HOUR_SECONDS,
  MINUTE_SECONDS,
  SECOND,
} from '../../../../constants/date'
import { GRETA_THINKING_STAGES } from '../../GretaAIChat.constants'

export function getGretaAIChatThinkingStageTextKey(elapsedMs) {
  return GRETA_THINKING_STAGES.reduce(
    (current, candidate) =>
      elapsedMs >= candidate.afterMs ? candidate : current,
    GRETA_THINKING_STAGES[0]
  ).textKey
}

export function getGretaAIChatElapsedMs(turnStartedAt) {
  return turnStartedAt ? Date.now() - turnStartedAt : 0
}

export function getGretaAIChatElapsedLabel(t, elapsedMs) {
  const totalSeconds = Math.floor(elapsedMs / SECOND)

  if (totalSeconds < MINUTE_SECONDS) {
    return t('Greta.ThinkingElapsedSecondsKey', { count: totalSeconds })
  }

  if (totalSeconds < HOUR_SECONDS) {
    return t('Greta.ThinkingElapsedMinutesKey', {
      minutes: Math.floor(totalSeconds / MINUTE_SECONDS),
      seconds: totalSeconds % MINUTE_SECONDS,
    })
  }

  return t('Greta.ThinkingElapsedHoursKey', {
    hours: Math.floor(totalSeconds / HOUR_SECONDS),
    minutes: Math.floor((totalSeconds % HOUR_SECONDS) / MINUTE_SECONDS),
  })
}
